/* eslint-disable no-secrets/no-secrets */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Icon, ToggleField } from '@jutro/components';
import { DropdownSelectField } from '@jutro/components/internal';
import { useTranslator } from '@jutro/locale';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './EmployeeInformation.metadata.json5';
import messages from './EmployeeInformation.messages';

function EmployeeInformation(props) {

    const {
        data: employeeInfoVM,
        updateWizardData,
        submissionVM,
        empInfoPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator()

    const addEmpInfo = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            employeeInfoVM.value = employeeInfoVM.value || []

            const { _xCenter, _dtoName } = employeeInfoVM;

            const EmpInfoObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            EmpInfoObjVM.isValidationReq = true;
            EmpInfoObjVM.seqNum = employeeInfoVM?.value?.length + 1;

            employeeInfoVM.pushElement(
                EmpInfoObjVM
            );
            updateWizardData(submissionVM);
        },
        [employeeInfoVM, viewModelService, updateWizardData, submissionVM]
    );


    const calculateNumberofEmpAndTotalEmp = useCallback(() => {

        const fullTimeEmp = employeeInfoVM.value.filter((item) => item.fultimPartimorConFie === 'FulTim').length
        const partTimeEmp = employeeInfoVM.value.filter((item) => item.fultimPartimorConFie === 'ParTim').length
        const conEmp = employeeInfoVM.value.filter((item) => item.fultimPartimorConFie === 'Con').length

        const fullTimePartTimeCon = employeeInfoVM.value.filter((item) => item.fultimPartimorConFie !== undefined).length

        _.set(submissionVM, 'lobData.spaAndWellLine.coverables.beauticiansSpa.businessInformation.numofPartimEmpFie.value', partTimeEmp)
        _.set(submissionVM, 'lobData.spaAndWellLine.coverables.beauticiansSpa.businessInformation.numofFultimEmpFie.value', fullTimeEmp)
        _.set(submissionVM, 'lobData.spaAndWellLine.coverables.beauticiansSpa.businessInformation.numofConEmpFie.value', conEmp)
        _.set(submissionVM, 'lobData.spaAndWellLine.coverables.beauticiansSpa.businessInformation.totEmpFie.value', fullTimePartTimeCon)
    }, [employeeInfoVM.value, submissionVM])

    const handleValueChange = useCallback(
        (value, path,) => {
            if (path === 'fultimPartimorConFie') {
                calculateNumberofEmpAndTotalEmp()
            }

            updateWizardData(submissionVM);
        },
        [calculateNumberofEmpAndTotalEmp, submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            employeeInfoVM.value.splice(index, 1);

            employeeInfoVM.value.map((employee) => {
                if(employee.seqNum > index) {
                    employee.seqNum = employee.seqNum - 1;
                }
            })

            _.set(submissionVM.value, empInfoPath, employeeInfoVM.value);
            calculateNumberofEmpAndTotalEmp()
            updateWizardData(submissionVM);
        }, [employeeInfoVM.value, submissionVM, empInfoPath, calculateNumberofEmpAndTotalEmp, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'seqNum') {
                const value = item.seqNum ? item.seqNum : index + 1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'namFie') {
                const value = item.namFie ? item.namFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaofEduFie') {
                const value = item.yeaofEduFie ? item.yeaofEduFie : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaofEduFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaofExpFie') {
                const value = item.yeaofExpFie ? item.yeaofExpFie : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaofExpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


            if (path === 'dutFie') {
                const value = item.dutFie ? item.dutFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.dutFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'fultimPartimorConFie') {
                const value = item.fultimPartimorConFie ? item.fultimPartimorConFie : '';

                const availableValues = employeeInfoVM.length > 0 && employeeInfoVM.children[index].fultimPartimorConFie
                    ? employeeInfoVM.children[index].fultimPartimorConFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="string"
                        onValueChange={(val, changedPath) => {
                            item.fultimPartimorConFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        availableValues={availableValues}
                    />
                );
            }

            if (path === 'cerAttFie') {
                const value = item.cerAttFie !== undefined ? item.cerAttFie : '';

                return (
                    <ToggleField
                        availableValues={[
                            {
                                code: 'true',
                                name: translator(messages.certificationYes)
                            },
                            {
                                code: 'false',
                                name: translator(messages.certificationNo)
                            }
                        ]}
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        onValueChange={(val, changedPath) => {
                            item.cerAttFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [employeeInfoVM.children, employeeInfoVM.length, handleValueChange, translator])

    const removeEmpInfoTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`EmployeeInfoTable`]: {
            data: employeeInfoVM?.value?.sort((a,b) => a.seqNum - b.seqNum)
        }

    }), [employeeInfoVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addEmpInfo,
            getTableCell,
            removeEmpInfoTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            employeeInfoVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [employeeInfoVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={employeeInfoVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

EmployeeInformation.propTypes = wizardProps;
export default withRouter(EmployeeInformation);
